<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrOdenekTalep from "@/models/StrOdenekTalep";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import store from "@/state/store";
const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 500);
};

export default {
  mixins: [Api, Sabit, StrOdenekTalep],
  props: ["Id2"],
  data() {
    return {
    OPersonelid: null,
      FormData: {},
      UserEmail : store.getters["auth/UserEMail"],
      FormDatas: [],
      Hesapkoduids: [],
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele: "Add",
      file: "",
      aktif_arama: false,
      AdminRoleKontrol: false,
      Tarih: moment(new Date()).format("YYYY-MM-DD"),
      Page: {
        PageNumber: "1",
        PageSize: "9999",
                PageDataSize: "1",
      },
      Hesapkodlari: [],
      TabloDetayVerileri: []
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    BirimSecimi,
    // formtreeselect,
    Treeselect,
  },
  watch: {
    Id2() {
      this.FormData = this.Id2;
              this.GetFormDatas(this.Id2.GrupGuid);
        this.aktif_arama = false;

        this.ActionsFilterGet({
          Service: "StrKontrolGirisKanit",
          Page: this.Page,
          Filter: "&Odenekid=" + this.Id2.Ids[0],
        }).then((res) => {
          this.TabloDetayVerileri = res.Data;
          this.Page.PageDataSize = res.TotalCount;

        });

        this.FormDataType.Altfaaliyet.ComboDataArray = [];
        let Filter = "&Ustid=" + this.Id2.Faaliyet;
        this.ActionsFilterGet({
          Service: "StrProgramFaaliyetKodlari",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          for (var c = 0; c < res.Data.length; c++) {
            this.FormDataType.Altfaaliyet.ComboDataArray.push({
              Id: res.Data[c].Id,
              Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
            });
          }
        });
        this.FormDataType.Altprogram.ComboDataArray = [];
        let Filter2 = "&Ustid=" + this.Id2.Program;
        this.ActionsFilterGet({
          Service: "StrProgramFaaliyetKodlari",
          Page: this.Page,
          Filter: Filter2,
        }).then((res) => {
          for (var n = 0; n < res.Data.length; n++) {
            this.FormDataType.Altprogram.ComboDataArray.push({
              Id: res.Data[n].Id,
              Value: res.Data[n].Kod + "-" + res.Data[n].Aciklama,
            });
          }
        });


      setTimeout(() => {
        this.aktif_arama = true;
      }, 200);
    },
    FormDatas() {
      this.Hesapkoduids = [];
    },
  },
  methods: {
    onSubmit() {
      if (this.FormData.Fileurl != "" || this.FormData.Aciklama != "") {

          if (this.FormDatas.length > 0) {
            var count = 0;
            for (var Data in this.FormDatas) {
              count = count + 1;
              if (this.FormDatas[Data].Id) {
                this.FormDatas[Data].GrupGuid = this.FormDatas[0].Grupguid;
                this.FormDatas[Data].Created = this.FormData.Created;
                this.FormDatas[Data].Createdby = this.FormData.Createdby;
                this.FormDatas[Data].Birimid = this.FormData.Birimid;
                this.FormDatas[Data].Yil = this.FormData.Yil;
                this.FormDatas[Data].Ay = this.FormData.Ay;
                this.FormDatas[Data].Gidertur = this.FormData.Gidertur;
                this.FormDatas[Data].Program = this.FormData.Program;
                this.FormDatas[Data].Altprogram = this.FormData.Altprogram;
                this.FormDatas[Data].Faaliyet = this.FormData.Faaliyet;
                this.FormDatas[Data].Altfaaliyet = this.FormData.Altfaaliyet;
                this.FormDatas[Data].Fileurl = this.FormData.Fileurl;
                this.FormDatas[Data].Aciklama = this.FormData.Aciklama;
                this.FormDatas[Data].Onay = true;
                this.FormDatas[Data].Revize = false;
                this.FormDatas[Data].Iptal = false;
                this.FormDatas[Data].Onayaciklama = this.FormData.Onayaciklama;
                this.FormDatas[Data].Onaypersonelid = this.OPersonelid;
                this.Update("StrOdenekTalep", this.FormDatas[Data], false).then(
                  (res) => {
                    if (res) {
                      this.$emit("Update", this.FormData);
                      if (this.FormDatas.length == count) {
                        this.$bvModal.hide("StrOdenekTalepOnay");
                        this.$toast.success('Onay İşlemi Başarılı');
                      }
                    }
                  });
              }
            }
          } else {
            this.$toast.error(
              "Minimum bir adet hesap kodu ve koda bağlı tutarları doldurunuz!"
            );
          }

      } else {
        this.$toast.error("Açıklama ya da dosya ekleyiniz.");
      }
    },
    GetFormDatas(Id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsFilterGet({
        Service: "StrOdenekTalep/GetFormDatas",
        Page: Page,
        Filter: "&GrupGuid=" + Id,
      }).then((res) => {
        this.FormDatas = [];
        for (var data in res.Data) {
          this.FormDatas.push(res.Data[data]);
        }
      });
    },
    Get() {
      this.$emit("TableUpdate");
      this.currentDate = new Date();
    },
        indir(file, filename) {
      let dosya_adi = file.substr(4, file.length - 4);
      let uzanti = file.substr(file.lastIndexOf(".") + 1);
      let Filter = "?fileName=" + dosya_adi + "&pathUrl=Str";

      this.ActionsFileGet({
        Service: "GenericFileUpDownload/DownloadFile",
        Filter,
      }).then((res) => {
        if (res) {
          /*
           var FILE = window.URL.createObjectURL(new Blob([res.Data]));
           
           var docUrl = document.createElement('x');
           docUrl.href = FILE;
           docUrl.setAttribute('download', 'file1.pdf');
           document.body.appendChild(docUrl);
           docUrl.click();
           */

          let blob = new Blob([res]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          if (filename == "") {
            link.download = dosya_adi;
            link.click();
          } else {
            link.download = filename + "." + uzanti;
            link.click();
          }
        }
      });
    },
    loadOptions({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          this.options = this.hesapkodlari;

          callback(null, this.options);
        });
      }
    },
    AltProgramSecimi(Program) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.FormDataType.Altprogram.ComboDataArray = [];
      let Filter = "&Ustid=" + Program;

      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: Page,
        Filter,
      }).then((res) => {
        for (var c = 0; c < res.Data.length; c++) {
          this.FormDataType.Altprogram.ComboDataArray.push({
            Id: res.Data[c].Id,
            Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
          });
        }
      });
    },
    AltFaaliyetSecimi(Program) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.FormDataType.Altfaaliyet.ComboDataArray = [];
      let Filter = "&Ustid=" + Program;

      this.ActionsFilterGet({
        Service: "StrProgramFaaliyetKodlari",
        Page: Page,
        Filter,
      }).then((res) => {
        for (var c = 0; c < res.Data.length; c++) {
          this.FormDataType.Altfaaliyet.ComboDataArray.push({
            Id: res.Data[c].Id,
            Value: res.Data[c].Kod + "-" + res.Data[c].Aciklama,
          });
        }
      });
    },
    liste_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length >= 1) {
        this.hesapkodlari = [];

        let Filter = "";
        if (veri[0] == "0" && veri[2] == ".") {
          Filter = "&Basamak=4&KodForLike=" + veri;
        } else {
          Filter = "&Basamak=4&Aciklama=" + veri;
        }

        this.ActionsFilterGet({
          Service: "StrHesapKodlari",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            this.hesapkodlari.push({
              id: res.Data[i].Id,
              label: res.Data[i].Kod + " - " + res.Data[i].Aciklama,
            });
          }
        });
      }
    },
    onSelectionChange(selectedIds) {
      const previouslySelected = this.FormData.Hesapkoduids;
      const newlyAddedIds = selectedIds.filter(
        (id) => !previouslySelected.includes(id)
      );

      if (newlyAddedIds.length > 0) {
        const newId = newlyAddedIds[0];
        this.FormData.Hesapkoduids.push(newId);
        const secilenHesapKodu = this.Hesapkodlari.find(
          (item) => item.id === newId
        );
        const newForm = {
          HesapKod: secilenHesapKodu.label,
          Hesapkodid: newId,
          Serbestodenek: null,
          Blokeodenek: null,
          Harcananodenek: null,
          Talepedilenodenek: null,
        };
        this.FormDatas.push(newForm);
      }

      //   this.FormData.Hesapkoduids = selectedIds;
    },


  },
  created() {
    let YetkiSorgu = this.UserRolles.filter(
      (item) => item.includes("SuperAdmin") || item.includes("StrAdmin")
    );
    if (YetkiSorgu.length != 0) this.AdminRoleKontrol = true;

    this.ActionsFilterGet({
      Service: "StrHesapKodlari",
      Page: this.Page,
      Filter: "&Basamak=4",
    }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.Hesapkodlari.push({
          id: res.Data[i].Id,
          label: res.Data[i].Aciklama,
        });
      }
    });
            let Filter = "&Eposta=" + this.UserEMail;
      this.ActionsFilterGet({
        Service: "OPersonel",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.OPersonelid = res.Data[0].Id;
      });
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrOdenekTalepOnay"
      size="xl"
      title="Onay"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-6">
            <BirimSecimi
              :title="FormDataType.Birimid.FieldTitle"
              :sutun="'0'"
              :title_class="'mb-3'"
              :selected="FormData.Birimid"
              :v="$v.FormData.Birimid"
              :YetkiKontrol="1"
              :multiple="false"
              :BirimTipId="null"
              @Secilmis_Idler="FormData.Birimid = $event"
              :class="{ disabled: true }"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Gidertur"
              :Value="FormData.Gidertur"
              :v="$v.FormData.Gidertur"
              @input="FormData.Gidertur = $event"
              :class="{ disabled: true }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Yil"
              :Value="FormData.Yil"
              :v="$v.FormData.Yil"
              @input="FormData.Yil = $event"
              :class="{ disabled: true }"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Ay"
              :Value="FormData.Ay"
              :v="$v.FormData.Ay"
              @input="FormData.Ay = $event"
              :class="{ disabled: true }"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Program"
              :Value="FormData.Program"
              :v="$v.FormData.Program"
              @input="(FormData.Program = $event), AltProgramSecimi($event)"
              :class="{ disabled: true }"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Altprogram"
              :Value="FormData.Altprogram"
              :v="$v.FormData.Altprogram"
              @input="FormData.Altprogram = $event"
              :class="{ disabled: true }"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Faaliyet"
              :Value="FormData.Faaliyet"
              :v="$v.FormData.Faaliyet"
              @input="(FormData.Faaliyet = $event), AltFaaliyetSecimi($event)"
              :class="{ disabled: true }"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Altfaaliyet"
              :Value="FormData.Altfaaliyet"
              :v="$v.FormData.Altfaaliyet"
              @input="FormData.Altfaaliyet = $event"
              :class="{ disabled: true }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12" v-if="1 == 0">
            <b-form-group
              class="mb-3"
              id="example text"
              label="Hesap Kodu"
              label-for="text"
            >
              <treeselect
                name="'Hesapkoduids'"
                id="'Hesapkoduids'"
                @search-change="liste_yukle($event)"
                :async="aktif_arama"
                :load-options="loadOptions"
                :options="FormDataType.Hesapkoduids.ComboDataArray"
                :multiple="true"
                :cacheOptions="false"
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..."
                v-model="Hesapkoduids"
                @input="onSelectionChange($event)"
              />
              <treeselect-value :value="Hesapkoduids" />
            </b-form-group>
          </div>
        </div>
        <div class="row mt-2 mb-3" v-for="data in FormDatas" :key="data.Id">
          <div class="custom2-col mt-4">
            <div>{{ data.HesapKod }}</div>
          </div>
          <div class="custom-col">
            <b-form-group label="Serbest Ödenek">
              <b-form-input
                v-model="data.Serbestodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                :class="{ disabled: true }"
                v-b-tooltip.hover
                title="e-bütçeden"
              ></b-form-input>
            </b-form-group>
          </div>
          <!--   <div class="custom-col">
            <b-form-group label="Bloke Ödenek">
              <b-form-input
                v-model="data.Blokeodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                :class="{ disabled: true }"
              ></b-form-input>
            </b-form-group>
          </div> -->
          <div class="custom-col">
            <b-form-group label="Harcanan Ödenek">
              <b-form-input
                v-model="data.Harcananodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                :class="{ disabled: true }"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="custom-col" v-if="AdminRoleKontrol == true">
            <b-form-group label="Kalan Ödenek">
              <b-form-input
                v-model="data.Kalanodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                :class="{ disabled: true }"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="custom-col">
            <b-form-group label="Ödeme Tutarı">
              <b-form-input
                v-model="data.Odemetutari"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                :class="{ disabled: true }"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="custom-col">
            <b-form-group label="Talep Edilen Ödenek">
              <b-form-input
                v-model="data.Talepedilenodenek"
                type="number"
                step="100"
                placeholder="0.00"
                :class="{ disabled: true }"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="custom-col" v-if="AdminRoleKontrol == true">
            <b-form-group label="Karşılanan Ödenek">
              <b-form-input
                v-model="data.Karsilananodenek"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered mb-0">
            <tbody>
              <tr>
                <th scope="col">
                  {{ $t("StrKontrolGirisKanit.Table.KanitAdi") }}
                </th>

                <th scope="col"></th>
              </tr>
              <tr v-for="(Data, index) in TabloDetayVerileri" :key="index">
                <td class="d-flex">
                  <div v-if="Data.Fileurl != '' && Data.Link == ''">
                    {{ Data.Filename }}
                  </div>
                  <div v-if="Data.Link != '' && Data.Fileurl == ''">
                    <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
                  </div>
                  <div v-if="Data.Link != '' && Data.Fileurl != ''">
                    {{ Data.Filename }} <br />
                    <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
                  </div>
                </td>
                <td>
                  <div v-if="Data.Fileurl != ''">
                    <i
                      style="margin-left:10px"
                      @click="indir(Data.Fileurl, Data.Filename)"
                      class="fas fa-download"
                    >
                    </i>
                  </div>
                </td>
              </tr>
                      <tr v-if="FormData.Fileurl">
                  <td class="d-flex">
                    <div>
                      Mevcut Dosya
                    </div>
                  </td>
                  <td>
                    <div class="row text-center">
                      <a
                        v-if="FormData.Fileurl"
                        :href="
                          this.$config.FILES_URL + 'str/' + FormData.Fileurl
                        "
                        target="_blanl"
                      >
                        <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i>
                      </a>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Aciklama"
              :Value="FormData.Aciklama"
              :v="$v.FormData.Aciklama"
              @input="FormData.Aciklama = $event"
              :class="{ disabled: true }"
            />
          </div>
        </div>

        <div class="row" v-if="AdminRoleKontrol == true">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Onayaciklama"
              :Value="FormData.Onayaciklama"
              :v="$v.FormData.Onayaciklama"
              @input="FormData.Onayaciklama = $event"
            />
          </div>
        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrOdenekTalep.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.85;
}
.custom-col {
  flex: 0 0 14%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 14%;
}
.custom2-col {
  flex: 0 0 16%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 16%;
}
</style>
